import { useNavigate } from "react-router";
import React, { useEffect, useRef, useState } from "react";
import { PaginationInterface, initRows } from "components/DataGrid";
import { FormProvider, useForm } from "react-hook-form";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import {
  BtnDeleteOnTable,
  BtnEditOnTable,
  BtnExamineOnTable,
  BtnViewOnTable,
} from "components/Button/ButtonTable";
import { ConvertDateToUnixOrNull, DefaultArrayEmpty, FnAxios, FnDialog, I18n } from "utilities/utilities";
import moment from "moment";
import UploadFileItem from "components/Input/UploadFile";
import { Chip, Grid, Tooltip } from "@mui/material";
import { EnumStatusActivity } from "enum/enum";
import { GetMenuPermission } from "utilities/SystemFunction";
am4core.addLicense("CH208466903");
am4core.useTheme(am4themes_animated);

export const useFollowUpGrid = () => {
  const navigate = useNavigate();
  const AxiosFn = FnAxios();
  const DialogFn = FnDialog();
  const [isPermission, setIsPermission] = useState<boolean>(false); // Permission

  useEffect(() => {
    GetMenuPermission(AxiosFn, setIsPermission, DialogFn);
  }, []);

  const dataColumn = [
    {
      headerName: "ดำเนินการ",
      field: "",
      type: "actions",
      resizable: false,
      sortable: false,
      width: 100,
      getActions: (item) => {
        return [
          <>
            {isPermission ?
              <BtnEditOnTable
                key={item.row.sID}
                id="btnEdit"
                onClick={() => handleEdit(item.row.sID)}
              />
              :
              <BtnViewOnTable
                key={item.row.sID}
                id="btnEdit"
                onClick={() => handleEdit(item.row.sID)}
              />
            }
          </>
        ];
      },
    },
    {
      field: "sAction",
      headerName: "สถานะ",
      headerAlign: "center",
      editable: false,
      resizable: false,
      align: "center",
      sortable: true,
      width: 120,
      renderCell: (item) => {
        let sColor = "#f1416c";
        let sBG = "#fff5f8";
        if (EnumStatusActivity.isApproved === item.row.nStatusID) {
          sColor = "rgb(22 187 68)";
          sBG = "rgb(231 255 237)"
        }
        if (EnumStatusActivity.isReported === item.row.nStatusID) {
          sColor = "#FFA500";
          sBG = "#FCF695"
        }
        return (
          <Tooltip title={item.row.sAction}>
            <Chip
              size="medium"
              label={item.row.sAction}
              style={{
                color: sColor,
                backgroundColor: sBG,
                margin: "0.2rem",
                fontSize: "0.8rem"
              }}
            />
          </Tooltip>
        )
      }
    },
    {
      field: "sOrder",
      headerName: "เลขที่",
      headerAlign: "center",
      align: "center",
      resizable: false,
      sortable: true,
      width: 120,
    },
    {
      field: "sActivity",
      headerName: "กิจกรรม",
      headerAlign: "center",
      align: "left",
      resizable: false,
      sortable: true,
      flex: 2,
      minWidth: 160,
    },
    {
      field: "sDueDate",
      headerName: "วันที่กำหนดส่ง",
      headerAlign: "center",
      editable: false,
      resizable: false,
      align: "center",
      sortable: true,
      width: 160,
    },
    {
      field: "sReportDate",
      headerName: "วันที่บันทึกผล",
      headerAlign: "center",
      editable: false,
      resizable: false,
      align: "center",
      sortable: true,
      width: 160,
    },
    {
      field: "isVerified",
      headerName: "การตรวจสอบ",
      headerAlign: "center",
      editable: false,
      resizable: false,
      align: "center",
      sortable: true,
      width: 120,
      renderCell: (item) => {
        return [
          <>
            {item.row.isVerified && (
              <BtnExamineOnTable
                key={item.row.sID}
                id="btnExamine"
                onClick={() => { }}
              />
            )}
          </>,
        ];
      },
    },
  ];

  const dataColumnApprover = [
    {
      headerName: "ดำเนินการ",
      field: "",
      type: "actions",
      resizable: false,
      sortable: false,
      width: 80,
      getActions: (item) => {
        return [
          <>
            {
              isPermission ? (
                <BtnEditOnTable
                  key={item.row.sID}
                  id="btnEdit"
                  onClick={() => handleEdit(item.row.sID, true)}
                />
              ) : (
                <BtnViewOnTable
                  id="btnView"
                  key={item.row.sID}
                  onClick={() => handleEdit(item.row.sID, true)}
                />
              )
            }
          </>
        ];
      },
    },
    {
      field: "sAction",
      headerName: "สถานะ",
      headerAlign: "center",
      editable: false,
      resizable: false,
      align: "center",
      sortable: false,
      width: 100,
      flex: 1,
      renderCell: (item) => {
        let sColor = "#f1416c";
        let sBG = "#fff5f8";
        if (EnumStatusActivity.isApproved === item.row.nStatusID) {
          sColor = "rgb(22 187 68)";
          sBG = "rgb(231 255 237)"
        }
        if (EnumStatusActivity.isReported === item.row.nStatusID) {
          sColor = "#FFA500";
          sBG = "#FCF695"
        }
        return (
          <Tooltip title={item.row.sAction}>
            <Chip
              size="medium"
              label={item.row.sAction}
              style={{
                color: sColor,
                backgroundColor: sBG,
                margin: "0.2rem",
                fontSize: "0.8rem"
              }}
            />
          </Tooltip>
        )
      }
    },
    {
      field: "sPerson",
      headerName: "ผู้รับมอบหมาย",
      headerAlign: "center",
      align: "left",
      resizable: false,
      sortable: true,
      flex: 2,
      minWidth: 160,
    },
    {
      field: "sOrder",
      headerName: "เลขที่",
      headerAlign: "center",
      align: "center",
      resizable: false,
      sortable: true,
      width: 100,
    },
    {
      field: "sActivity",
      headerName: "กิจกรรม",
      headerAlign: "center",
      align: "left",
      resizable: false,
      sortable: true,
      flex: 2,
      minWidth: 160,
    },
    {
      field: "sDueDate",
      headerName: "วันที่กำหนดส่ง",
      headerAlign: "center",
      editable: false,
      resizable: false,
      align: "center",
      sortable: true,
      width: 130,
    },
    {
      field: "sReportDate",
      headerName: "วันที่บันทึกผล",
      headerAlign: "center",
      editable: false,
      resizable: false,
      align: "center",
      sortable: true,
      width: 130,
    },
    {
      field: "isVerified",
      headerName: "การตรวจสอบ",
      headerAlign: "center",
      editable: false,
      resizable: false,
      align: "center",
      sortable: true,
      width: 100,
      renderCell: (item) => {
        return [
          <>
            {item.row.isVerified && (
              <BtnExamineOnTable
                key={item.row.sID}
                id="btnExamine"
                onClick={() => { }}
              />
            )}
          </>,
        ];
      },
    },
  ];

  const handleEdit = (sID: string, IsApprove = false) => {
    if (IsApprove) {
      navigate(`/FollowUpApprove?sActivityID=${sID}`);
    } else {
      navigate(`/FollowUpReport?sActivityID=${sID}`);
    }

  };

  return { dataColumn, dataColumnApprover, isPermission };
};

export const useFollowUpTable = (IsApprover = false) => {

  const AxiosFn = FnAxios();
  const DialogFn = FnDialog();
  const [isLoading, setIsLoading] = useState(false);
  const [objTask, setObjTask] = useState({} as any);
  const [objInProgress, setObjInProgress] = useState({} as any);
  const [objCompleted, setObjCompleted] = useState({} as any);
  const [nYear, setNYear] = useState(null);
  const [dataActivity, setDataActivity] = useState([]);
  const [lstFileMOU, setLstFileMOU] = useState([]);
  const [lstFilePlan, setLstFilePlan] = useState([]);
  const [startYear, setStartYear] = useState(new Date().getFullYear() + 543);
  const [selectYear, setSelectYear] = useState(
    new Date().getFullYear() + 543
  );
  const [open, setOpen] = useState(false);
  const [loadingPlan, setLoadingPlan] = useState(false);
  const [loadingComplete, setLoadingComplete] = useState(false);

  const form = useForm({
    shouldFocusError: true,
    mode: "all",
    defaultValues: {} as any,
  });
  const [dataRow, setDataRow] = useState<PaginationInterface>({
    ...initRows,
    sSortExpression: "sDueDate",
    sSortDirection: "desc"
  });


  const handleOpen = (value) => {
    setOpen(value);
  };

  const handleClose = () => {
    handleOpen(false);
    setTimeout(() => {
      setLoadingComplete(false)
    }, 500)
  }

  const onGetPlanYear = () => {
    setLoadingPlan(true);
    AxiosFn.Get(`FundActionPlan/GetDataFundActionPlanOverview`, { nYear: selectYear - 543 }, (result) => {
      if (result.objResult) {
        let lstStrategic = [...result.objResult.lstStrategic];
        let listFileMOU = [...result.objResult.lstFileMOU];
        let listFilePlan = [...result.objResult.lstFilePlan];
        setDataActivity(lstStrategic);
        setLstFileMOU(listFileMOU);
        setLstFilePlan(listFilePlan);
      } else {
        setDataActivity([]);
        setLstFileMOU([]);
        setLstFilePlan([]);
      }

      setLoadingPlan(false);
      setLoadingComplete(true);
    });
  };

  const handleExportExcel = (nYear) => {

    let sFileName = `การติดตามผลการดำเนินงานของกองทุนจัดการซากดึกดำบรรพ์ ${nYear + 543}.xlsx`;

    AxiosFn.DowloadFileBlob(`FundActionPlan/ExportExcelReport`, { nYear: nYear }, sFileName, (result) => {

    }, (err) => {

    }, DialogFn.BlockUI(), DialogFn.UnBlockUI());
  }

  const onGetData = (p) => {

    setIsLoading(true);

    let lstPerson = form.getValues("sPerson");
    if (!lstPerson) {
      lstPerson = [];
    }
    let dStart = moment(form.getValues("sResultDateStart"));
    let dEnd = moment(form.getValues("sResultDateEnd"));
    let lstYear = form.getValues("sYear");
    let lstQuarter = form.getValues("sQuarter");
    let lstAction = form.getValues("sStatus");

    let param = {
      sSortDirection: p.sSortDirection,
      sSortExpression: p.sSortExpression,
      nPageIndex: p.nPageIndex,
      nPageSize: p.nPageSize,
      sYear: DefaultArrayEmpty(lstYear).join(","),
      sPerson: DefaultArrayEmpty(lstPerson).join(","),
      sQuarter: DefaultArrayEmpty(lstQuarter).join(","),
      sAction: DefaultArrayEmpty(lstAction).join(","),
      nDateStart: dStart.isValid() ? ConvertDateToUnixOrNull(dStart) : null,
      nDateEnd: dEnd.isValid() ? ConvertDateToUnixOrNull(dEnd) : null,
      IsApprover: IsApprover
    }

    AxiosFn.Get(`FundActionPlan/GetFundReport`, param, (result) => {
      let data = result.objResult.result;
      setIsLoading(false);
      if (data) {
        setDataRow({
          ...p,
          arrRows: [...data.lstData],
          nDataLength: data.nDataLength
        })
      } else {
        setDataRow({
          ...p,
          arrRows: [],
          nDataLength: 0
        })
      }
    });
  };

  const onClear = () => {
  };

  useEffect(() => {
    onGetData(dataRow);
    GetDashBoard();
  }, []);

  const GetDashBoard = () => {
    AxiosFn.Get(`FundActionPlan/GetReportGraph`, {}, (result) => {
      let data = result.objResult;
      if (data.lstDashboard) {
        let lstDashboard = [...data.lstDashboard];
        setObjTask({ ...lstDashboard.find(f => f.sID === "Task") })
        setObjInProgress({ ...lstDashboard.find(f => f.sID === "InProgress") })
        setObjCompleted({ ...lstDashboard.find(f => f.sID === "Completed") })
      }
      setNYear(data.nYear);
      createDonut(data.lstChart);
    });
  }

  const createDonut = (data) => {
    let chart = am4core.create("chartdiv", am4charts.PieChart);
    chart.data = [...data];

    chart.innerRadius = 50;
    let label = chart.seriesContainer.createChild(am4core.Label);
    label.text = chart.data.map(m => m.size).reduce((a, b) => a + b, 0) + "";
    label.horizontalCenter = "middle";
    label.verticalCenter = "middle";
    label.fontSize = 20;

    let pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "size";
    pieSeries.dataFields.category = "sector";
    pieSeries.labels.template.disabled = true;
    pieSeries.ticks.template.disabled = true;
    pieSeries.slices.template.propertyFields.fill = "color";
    pieSeries.colors.list = [
      am4core.color("#ffdec1"),
      am4core.color("#dbf9e4"),

    ];
  };

  return { form, dataRow, onGetData, handleExportExcel, onClear, isLoading, objTask, objInProgress, objCompleted, nYear, open, handleClose, handleOpen, selectYear, startYear, setSelectYear, setStartYear, loadingComplete, loadingPlan, onGetPlanYear, dataActivity, lstFileMOU, lstFilePlan, setLstFileMOU, setLstFilePlan };
};

export const useFollowUpReview = (sID, IsApprovePage = false) => {
  const AxiosFn = FnAxios();
  const navigate = useNavigate();

  const [isPermission, setIsPermission] = useState<boolean>(false); // Permission

  useEffect(() => {
    GetMenuPermission(AxiosFn, setIsPermission, DialogFn);
  }, []);

  useEffect(() => {
    if (sID) {
      onGetDataActivity(sID);
      onGetInitTask();
    }
  }, [sID])
  const form = useForm({
    shouldFocusError: true,
    mode: "all",
    defaultValues: {} as any,
  });
  const formOther = useForm({
    shouldFocusError: true,
    mode: "all",
    defaultValues: {} as any,
  });
  const DialogFn = FnDialog();
  const [dataRow, setDataRow] = useState<PaginationInterface>({
    ...initRows,
  });
  const [dataRowOther, setDataRowOther] = useState<PaginationInterface>({
    ...initRows,
  });
  const [arrFileActivityList, setArrFileActivityList] = useState([] as any);
  const [arrFileCloseActivityList, setArrFileCloseActivityList] = useState(
    [] as any
  );
  const [arrFileActivityOtherList, setArrFileActivityOtherList] = useState(
    [] as any
  );
  const onClearFile = useRef(null);
  const onClearFileUnplan = useRef(null);
  const onClearFileClose = useRef(null);
  const [isOther, setIsOther] = useState(false);
  const [isClose, setIsClose] = useState(false);
  const [nMin, setNMin] = useState(null);
  const [nMax, setNMax] = useState(moment());
  const [nHour, setNHour] = useState("0");

  const [objData, setObjData] = useState({
    sVision: null,
    sMission: null,
    sGoal: null,
    sOrderStrategic: null,
    sOrderStrategy: null,
    sStrategic: null,
    sTarget: null,
    sStrategy: null,
    sProject: null,
    sActivity: null,
    lstSubActivity: [],
    sDuration: null,
    sIndicator: null,
    sWeight: null,
  });

  const [activityID, setActivityID] = useState("");
  const [activityOtherID, setActivityOtherID] = useState("");
  const [isOtherTask, setIsOtherTask] = useState(false);
  const [arrTypeUnplan, setArrTypeUnplan] = useState([]);
  const [arrGroupUnplan, setArrGroupUnplan] = useState([]);
  const [arrTaskUnplan, setArrTaskUnplan] = useState([]);
  const [arrAGroupUnplan, setArrAGroupUnplan] = useState([]);
  const [arrATaskUnplan, setArrATaskUnplan] = useState([]);

  const [isReport, setIsReport] = useState(false);
  const [isOrginal, setIsOrginal] = useState(false);
  const [sTextSubmit, setSTextSubmit] = useState(I18n.SetText("FundPlan.Approved"));

  const CheckButtonSubmit = (isCloseActivity) => {
    if (IsApprovePage) {
      // 1. กรณียังไม่รายงาน และ Check ปิดกิจกรรม >> แสดงปุ่มยืนยีน ซ่อนปุ่มตรวจสอบแล้ว
      // 2. กรณีรายงานแล้ว และ Check ปิดกิจกรรม >> ปุ่มตรวจสอบและยืนยัน
      // 3. กรณียังไม่รายงาน และ Uncheck ปิดกิจกรรม => แสดงปุ่มยืนยีน ซ่อนปุ่มตรวจสอบแล้ว
      // 4. กรณีรายงานแล้ว และ Uncheck ปิดกิจกรรม => แสดงปุ่มยืนยีน ซ่อนปุ่มตรวจสอบแล้ว
      // 5. กรณีรายงานแล้วและไม่ได้เลือกปิด/เปิด กิจกรรม => แสดงปุ่มตรวจสอบแล้ว

      let nHandle = 5; //not handle
      if (isReport) {
        if (isCloseActivity === isOrginal) {
          //eq defualt db
          nHandle = 5;
        } else if (isCloseActivity) {
          nHandle = 2;
        } else {
          nHandle = 4;
        }

      } else {
        if (isCloseActivity === isOrginal) {
          //eq defualt db
          nHandle = 5;
        } else if (isCloseActivity) {
          nHandle = 3;
        } else {
          nHandle = 1;
        }

      }

      switch (nHandle) {
        case 1:
        case 3:
        case 4:
          setSTextSubmit(I18n.SetText("FundPlan.Submit"));
          break;
        case 2:
          setSTextSubmit(I18n.SetText("FundPlan.Verify"));
          break;
        case 5:
          setSTextSubmit(I18n.SetText("FundPlan.Approved"));
      }
    }
  }

  const handleChangeOther = (e) => {
    setIsOther(e);
  };

  const handleChangeClose = (e) => {
    setIsClose(e);
    CheckButtonSubmit(e);
  };

  const onGetDataActivity = (sID) => {
    DialogFn.BlockUI();
    AxiosFn.Get(`FundActionPlan/GetActivity`, { sActivityID: sID }, (result) => {
      let data = result.objResult;
      DialogFn.UnBlockUI();
      if (data) {
        setObjData(data);
        form.setValue("sTopic", data.sActivity);
        if (moment(data.dReportDate).isValid()) {
          setIsReport(true);
        }
        OnSetReport(data.objReportProgress);
      }
    })
  }
  const OnSetReport = (data) => {
    setIsOther(data.isUnplan);
    formOther.setValue("isOther", data.isUnplan);
    setArrFileActivityList([...data.lstFileActual]);
    setDataRow({
      ...dataRow,
      arrRows: data.lstReportProgress,
    });

    setDataRowOther({
      ...dataRowOther,
      arrRows: data.lstUnplan,
    });

    let close = data.objClosed;
    form.setValue("isCloseActivity", close.isClose);
    setIsClose(close.isClose);
    setIsOrginal(close.isClose);
    form.setValue("sReason", close.sRemark);
    setArrFileCloseActivityList([...close.lstFileClose])
  }
  const onGetInitTask = () => {
    AxiosFn.Get(`FundActionPlan/GetInitUnplan`, {}, (result) => {
      let data = result.objResult;
      if (data) {
        setArrTypeUnplan([...data.lstTypeTask]);
        setArrAGroupUnplan([...data.lstGroup]);
        setArrATaskUnplan([...data.lstTask]);
      }
    })
  }

  const handleChangeUnplan = (e, sType) => {
    setIsOtherTask(false);
    formOther.setValue("sOtherTask", null);

    if (sType === "type") {
      setArrGroupUnplan([]);
      setArrTaskUnplan([]);
      formOther.setValue("sMeetingGroup", null);
      formOther.setValue("sOperation", null);

      if (e) {
        if (e.value === 6) {
          setIsOtherTask(true);
        }
        let group = [...arrAGroupUnplan].filter(f => f.nParentID === e.value)
        setArrGroupUnplan([...group]);
      }
    }

    if (sType === "group") {
      setArrTaskUnplan([]);
      formOther.setValue("sOperation", null);
      if (e) {
        let task = [...arrATaskUnplan].filter(f => f.nParentID === e.value)
        setArrTaskUnplan([...task]);
      }
    }
  }

  const onAddActivity = () => {
    let data = form.getValues();

    let dStart = moment(data.sDateStart);
    let dEnd = moment(data.sDateEnd);

    if (dStart.isSameOrBefore(dEnd)) {
      if (activityID !== "") {
        const oEditIndex = dataRow.arrRows.findIndex(
          (item) => item.sID === activityID
        );
        if (oEditIndex !== -1) {
          dataRow.arrRows[oEditIndex].nDateStart = ConvertDateToUnixOrNull(data.sDateStart);
          dataRow.arrRows[oEditIndex].nDateEnd = ConvertDateToUnixOrNull(data.sDateEnd);
          dataRow.arrRows[oEditIndex].sDateStart = dStart.add(543, "year").format("DD/MM/YYYY").toString();
          dataRow.arrRows[oEditIndex].sDateEnd = dEnd.add(543, "year").format("DD/MM/YYYY").toString();
          dataRow.arrRows[oEditIndex].nWeight = parseFloat(data.sWeight);
          dataRow.arrRows[oEditIndex].sRemark = data.sRemark;
          dataRow.arrRows[oEditIndex].IsDisabled = false;
          setActivityID("");
        }
      } else {
        let nMaxData =
          dataRow.arrRows.length > 0
            ? Math.max(...dataRow.arrRows.map((o) => o.nNo)) + 1
            : 1;
        let objActivity = {
          sID: nMaxData.toString(),
          nNo: nMaxData,
          nWorkActualID: null,
          nDateStart: ConvertDateToUnixOrNull(data.sDateStart),
          nDateEnd: ConvertDateToUnixOrNull(data.sDateEnd),
          sDateStart: moment(data.sDateStart).add(543, "year").format("DD/MM/YYYY").toString(),
          sDateEnd: moment(data.sDateEnd).add(543, "year").format("DD/MM/YYYY").toString(),
          nWeight: parseFloat(data.sWeight),
          sRemark: data.sRemark,
          IsDisabled: false
        };
        const newData = [...dataRow.arrRows, objActivity];
        setDataRow({
          ...dataRow,
          arrRows: newData,
        });
      }
      onClearActivity();
    } else {
      DialogFn.Warning("ข้อมูลระยะเวลาไม่ถูกต้อง", () => {
        form.setValue("sDateEnd", null);
        setNMax(moment());
      });
    }
  };

  const CheckWeightActivity = (weight) => {
    let data = [...dataRow.arrRows];
    if (activityID !== "") {
      data = data.filter((item) => item.sID !== activityID);
    }
    const sumWeight = data.reduce((acc, currentValue) => acc + currentValue.nWeight, 0);

    if ((sumWeight + parseFloat(weight)) > parseFloat(objData.sWeight)) {
      DialogFn.Warning(I18n.SetText("FundPlan.OverWeightActivity"), () => { form.setValue("sWeight", null) });
    }
  }

  const handleChangeTime = (type, event) => {
    let end = moment(formOther.getValues("tTimeend")).seconds(0).milliseconds(0);
    let start = moment(formOther.getValues("tTimestart")).seconds(0).milliseconds(0);

    if (type === "s") {
      start = moment(event).seconds(0).milliseconds(0);

    } else if (type === "e") {
      end = moment(event).seconds(0).milliseconds(0);
    }

    if (end.isValid() && start.isValid() && start.isAfter(end)) {
      DialogFn.Warning(I18n.SetText("FundPlan.TimeStratOver"), () => {
        formOther.setValue(`tTimeend`, null);
        formOther.setValue(`tTimestart`, null);
        end = null;
        start = null;
      }, () => {
        formOther.setValue(`tTimeend`, null);
        formOther.setValue(`tTimestart`, null);
        end = null;
        start = null;
      });
    }

    if (moment(start).isValid() && moment(end).isValid()) {
      let diff = moment(end).diff(moment(start));
      let duration = moment.duration(diff);
      if (duration.minutes() > 0) {
        setNHour(duration.hours() + "." + (duration.minutes() + "").padStart(2, '0'));
      } else {
        setNHour(duration.hours() + "");
      }
    } else {
      setNHour("0");
    }
  }

  const handleEdit = (sID: string) => {
    let oEdit = dataRow.arrRows.find((f) => f.sID === sID);
    if (oEdit) {
      setActivityID(sID);
      oEdit.IsDisabled = true;

      setNMin(moment(oEdit.nDateStart));
      setNMax(moment(oEdit.nDateEnd));

      form.setValue("sWeight", oEdit.nWeight);
      form.setValue("sRemark", oEdit.sRemark);
      form.setValue("sDateStart", moment(oEdit.nDateStart));
      form.setValue("sDateEnd", moment(oEdit.nDateEnd));

      dataRow.arrRows.filter(f => f.sID !== sID).forEach(item => {
        item.IsDisabled = false;
      })

      form.clearErrors();
    }
  };

  const CheckFormActivityOther = () => {
    if (
      (formOther.getValues("sWorkType") != null && formOther.getValues("sWorkType") !== "") ||
      (formOther.getValues("sDate") != null && formOther.getValues("sDate") !== "") ||
      (formOther.getValues("tTimestart") != null && formOther.getValues("tTimestart") !== "") ||
      (formOther.getValues("nTimeEnd") != null && formOther.getValues("nTimeEnd") !== "")
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleDelete = (sID: string) => {
    DialogFn.Submit("คุณการลบข้อมูลใช่หรือไม่?", () => {
      const filteredActivity = dataRow.arrRows.filter(
        (item) => item.sID !== sID
      );
      const updatedActivity = filteredActivity.map((item, index) => ({
        ...item,
        sID: index + 1,
        nNo: index + 1,
      }));
      setDataRow({
        ...dataRow,
        arrRows: updatedActivity,
      });
      setActivityID("");
      DialogFn.CloseSubmit();

      if (sID === activityID) {
        onClearActivity();
      }
    });
  };

  const onAddActivityOther = () => {
    let data = formOther.getValues();
    let clone = [...dataRowOther.arrRows];
    let nMaxData = dataRowOther.arrRows.length > 0 ? Math.max(...dataRowOther.arrRows.map((o) => o.nNo)) + 1 : 1;
    let sID = nMaxData.toString();
    let nActivityUnplanID = null;
    if (activityOtherID) {
      let objEdit = clone.find(f => f.sID === activityOtherID);
      if (objEdit) {
        sID = objEdit.sID;
        nActivityUnplanID = objEdit.nActivityUnplanID;
        nMaxData = objEdit.nNo;
        clone = clone.filter(f => f.sID !== activityOtherID);
      }
    }
    let sLevel1 = [...arrTypeUnplan].find(f => f.value === data.sWorkType)?.label;
    let sLevel2 = [...arrAGroupUnplan].find(f => f.value === data.sMeetingGroup)?.label ?? "";
    let sLevel3 = [...arrATaskUnplan].find(f => f.value === data.sOperation)?.label ?? "";

    let sDetail = sLevel1 + "\n" + sLevel2 + "\n" + sLevel3;

    if (data.sOtherTask) {
      sDetail = sLevel1 + "\n" + data.sOtherTask;
    }

    let obj = {
      sID: sID,
      nNo: nMaxData,
      nActivityUnplanID: nActivityUnplanID,
      isOther: data.isOther,
      nTaskLevel1ID: data.sWorkType,
      nTaskLevel2ID: data.sMeetingGroup,
      nTaskLevel3ID: data.sOperation,
      sTaskOther: data.sOtherTask,
      nDate: ConvertDateToUnixOrNull(data.sDate),
      nTimeStart: ConvertDateToUnixOrNull(data.tTimestart),
      nTimeEnd: ConvertDateToUnixOrNull(data.tTimeend),
      lstFileUnplan: arrFileActivityOtherList,
      sTotalTime: nHour,
      sDate: moment(data.sDate).add(543, "year").format("DD/MM/YYYY"),
      sDetail: sDetail,
      IsDisabled: false
    }
    const newData = [...clone, obj].sort((a, b) => a.nNo - b.nNo);
    setDataRowOther({
      ...dataRowOther,
      arrRows: newData,
    });
    setActivityOtherID("");
    onClearActivityOther();
  }

  const handleEditOther = (sID: string) => {
    if (CheckFormActivityOther()) {
      DialogFn.Warning(
        "มีข้อมูลระยะเวลาดำเนินงานที่ยังกรอกไม่เสร็จ คุณต้องการจะแก้ไขใช่หรือไม่ ?"
      );
      return false;
    }

    let oEdit = dataRowOther.arrRows.find((f) => f.sID === sID);
    if (oEdit) {
      setActivityOtherID(sID);
      oEdit.IsDisabled = true;
      formOther.setValue("sWorkType", oEdit.nTaskLevel1ID);
      formOther.setValue("sMeetingGroup", oEdit.nTaskLevel2ID);
      formOther.setValue("sOperation", oEdit.nTaskLevel3ID);
      formOther.setValue("sOtherTask", oEdit.sTaskOther);
      formOther.setValue("sDate", moment(oEdit.nDate));
      formOther.setValue("tTimestart", new Date(oEdit.nTimeStart));
      formOther.setValue("tTimeend", new Date(oEdit.nTimeEnd));
      setArrFileActivityOtherList([...oEdit.lstFileUnplan]);
      setNHour(oEdit.sTotalTime)
    }
  };

  const handleDeleteOther = (sID: string) => {
    DialogFn.Submit("คุณการลบข้อมูลใช่หรือไม่?", () => {
    });
  };

  const onClearActivity = () => {
    form.setValue("sDateStart", "");
    form.setValue("sDateEnd", "");
    form.setValue("sWeight", null);
    form.setValue("sRemark", "");
    setArrFileActivityList([]);
    onClearFile.current(null);
    setNMax(moment());
    setNMin(null);
  };

  const onClearActivityOther = () => {
    formOther.setValue("sWorkType", null);
    formOther.setValue("sMeetingGroup", null);
    formOther.setValue("sOperation", null);
    formOther.setValue("sOtherTask", null);
    formOther.setValue("sDate", null);
    formOther.setValue("tTimestart", null);
    formOther.setValue("tTimeend", null);
    setNHour("0");
    setArrFileActivityOtherList([]);
    setArrGroupUnplan([]);
    setArrTaskUnplan([]);
    onClearFileUnplan.current(null);
  };

  const onBack = () => {
    navigate(`/ProgressReport`);
  }

  const onBackApprove = () => {
    navigate(`/FollowUp`);
  }

  const handleSubmitApproved = () => {
    let sRemark = form.getValues("sReason");
    let lstFileClose = [...arrFileCloseActivityList];

    if (!isClose) {
      sRemark = null;
      lstFileClose = [];
    }

    let obj = {
      sActivityID: sID,
      isClose: isClose,
      sRemark: sRemark,
      lstFileClose: lstFileClose,
    }

    DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
      DialogFn.BlockUI();
      AxiosFn.Post(`FundActionPlan/OnApproved`, obj, (result) => {
        DialogFn.UnBlockUI();
        if (result.nStatusCode === 200) {
          DialogFn.Success(`บันทึกสำเร็จ`);
          DialogFn.CloseSubmit();
          navigate(`/FollowUp`);
        } else {
          DialogFn.Warning(result.sMessage);
        }
      }, (err) => {
        DialogFn.UnBlockUI();
        if (!err.response) {
          DialogFn.Warning(err.sMessage);
        }
      });
    });

  }

  const handleSubmit = () => {
    let obj = {
      sActivityID: sID,
      isUnplan: isOther,
      lstReportProgress: dataRow.arrRows,
      lstUnplan: dataRowOther.arrRows,
      lstFileActual: arrFileActivityList,
    }

    if ([...dataRow.arrRows].length === 0) {
      DialogFn.Warning("กรุณากรอกข้อมูลรายงานผล");
      return;
    }

    DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
      DialogFn.BlockUI();
      AxiosFn.Post(`FundActionPlan/OnReportProgress`, obj, (result) => {
        DialogFn.UnBlockUI();
        if (result.nStatusCode === 200) {
          DialogFn.Success(`บันทึกสำเร็จ`);
          DialogFn.CloseSubmit();
          navigate(`/ProgressReport`);
        } else {
          DialogFn.Warning(result.sMessage);
        }
      }, (err) => {
        DialogFn.UnBlockUI();
        if (!err.response) {
          DialogFn.Warning(err.sMessage);
        }
      });
    });

  }

  return {
    form,
    dataRow,
    setDataRow,
    arrFileActivityList,
    setArrFileActivityList,
    onClearFile,
    onClearFileUnplan,
    onClearFileClose,
    isOther,
    handleChangeOther,
    formOther,
    arrFileActivityOtherList,
    setArrFileActivityOtherList,
    dataRowOther,
    setDataRowOther,
    isClose,
    isReport,
    handleChangeClose,
    arrFileCloseActivityList,
    setArrFileCloseActivityList,
    onAddActivity,
    activityID,
    setActivityID,
    objData,
    handleEdit,
    handleDelete,
    CheckWeightActivity,
    activityOtherID,
    setActivityOtherID,
    onAddActivityOther,
    handleEditOther,
    handleDeleteOther,
    nMin,
    setNMin,
    nMax,
    setNMax,
    arrTypeUnplan,
    arrGroupUnplan,
    arrTaskUnplan,
    handleChangeUnplan,
    isOtherTask,
    handleChangeTime,
    nHour,
    onBack,
    handleSubmit,
    onBackApprove,
    handleSubmitApproved,
    sTextSubmit,
    isPermission
  };
};

export const useActivityGrid = (handleEdit, handleDelete, isView = false) => {
  let dataColumn = [
    {
      field: "nNo",
      headerName: "",
      headerAlign: "center",
      align: "center",
      resizable: false,
      sortable: true,
      width: 80,
    },
    {
      field: "sDateStart",
      headerName: "วันที่เริ่มต้น",
      headerAlign: "center",
      editable: false,
      resizable: false,
      align: "center",
      sortable: true,
      width: 160,
    },
    {
      field: "sDateEnd",
      headerName: "วันที่สิ้นสุด",
      headerAlign: "center",
      editable: false,
      resizable: false,
      align: "center",
      sortable: true,
      width: 160,
    },
    {
      field: "nWeight",
      headerName: "ตัวเลขร้อยละ",
      headerAlign: "center",
      align: "center",
      resizable: false,
      sortable: true,
      width: 120,
      renderCell: (item) => {
        let sWeight = item.row.nWeight.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

        return sWeight;
      }
    },
    {
      field: "sRemark",
      headerName: "หมายเหตุ",
      headerAlign: "center",
      align: "left",
      resizable: false,
      sortable: true,
      flex: 2,
      minWidth: 160,
    },
  ];

  if (!isView) {
    let objEdit = {
      headerName: "",
      field: "",
      type: "actions",
      resizable: false,
      sortable: false,
      width: 100,
      getActions: (item) => {
        return [
          <BtnDeleteOnTable
            key={item.row.sID}
            id={"btnDelete"}
            onClick={() => handleDelete(item.row.sID)}
          />,
          <BtnEditOnTable
            key={item.row.sID}
            id="btnEdit"
            onClick={() => handleEdit(item.row.sID)}
            IsDisabled={item.row.IsDisabled}
          />,
        ];
      },
    } as any;
    dataColumn = [objEdit, ...dataColumn];
  }

  return dataColumn;
};

export const useActivityOtherGrid = (handleEdit, handleDelete, isView = false) => {
  const formFile = useForm({
    shouldFocusError: true,
    mode: "all",
    defaultValues: {} as any,
  });

  let dataOtherColumn = [
    {
      field: "nNo",
      headerName: "",
      headerAlign: "center",
      align: "center",
      resizable: false,
      sortable: true,
      width: 80,
    },
    {
      field: "sDate",
      headerName: "วันที่",
      headerAlign: "center",
      editable: false,
      resizable: false,
      align: "center",
      sortable: true,
      width: 160,
    },
    {
      field: "sTotalTime",
      headerName: "จำนวนชั่วโมง",
      headerAlign: "center",
      editable: false,
      resizable: false,
      align: "center",
      sortable: true,
      width: 120,
    },
    {
      field: "sDetail",
      headerName: "รายละเอียดงาน",
      headerAlign: "center",
      align: "left",
      resizable: false,
      sortable: true,
      flex: 2,
      minWidth: 150,
    },
    {
      field: "fFileActivity",
      headerName: "หลักฐาน/เอกสารแนบ",
      headerAlign: "center",
      editable: false,
      resizable: false,
      align: "left",
      sortable: true,
      flex: 1,
      width: 160,
      renderCell: (item) => {
        return (
          <Grid item xs={12} md={12}>
            <FormProvider {...formFile}>
              <UploadFileItem
                required={false}
                modeDisplay={"list"}
                id={"oFileDocument"}
                name={"oFileDocument"}
                key={item.row.sID}
                IsDrag={false}
                arrFile={item.row.lstFileUnplan}
                setarrFile={() => { }}
                Extension={["pdf", "jpeg", "png"]}
                IsFolder={false}
                isFileChange={true}
                IsMultiple={true}
                onClearFile={() => { }}
                sFolderTemp="Leave"
                nLimitFile={10}
                sLimitFile="MB"
                sPositionText="right"
                IsMultiDelete={false}
                disabled={true}
                IsHide={true}
              />
            </FormProvider>
          </Grid>
        );
      }
    }
  ];

  if (!isView) {
    let objEdit = {
      headerName: "",
      field: "",
      type: "actions",
      resizable: false,
      sortable: false,
      width: 100,
      getActions: (item) => {
        return [
          <BtnDeleteOnTable
            key={item.row.sID}
            id={"btnDelete"}
            onClick={() => handleDelete(item.row.sID)}
          />,
          <BtnEditOnTable
            key={item.row.sID}
            id="btnEdit"
            onClick={() => handleEdit(item.row.sID)}
            IsDisabled={item.row.IsDisabled}
          />,
        ];
      },
    } as any;
    dataOtherColumn = [objEdit, ...dataOtherColumn];
  }

  return dataOtherColumn;
};
